import type { StoryFeedItem } from '../types'

/** История «просмотрена полностью». */
export const isStoryViewed = (item: StoryFeedItem): boolean =>
  Boolean(item.view.is_completed)

/**
 * Порядок ленты: сначала непросмотренные, затем просмотренные. Внутри каждой
 * группы сохраняется порядок бэка (он уже отсортирован по приоритету).
 * Доп. сортировку по просмотру бэк не делает — делаем на фронте.
 */
export const sortStoriesUnviewedFirst = (
  stories: StoryFeedItem[],
): StoryFeedItem[] => {
  const unviewed: StoryFeedItem[] = []
  const viewed: StoryFeedItem[] = []
  for (const s of stories) (isStoryViewed(s) ? viewed : unviewed).push(s)
  return [...unviewed, ...viewed]
}

/**
 * Индекс слайда, с которого открывать историю: первый непросмотренный
 * (slides[max_slide_viewed]). Если всё просмотрено — с начала (0).
 */
export const firstUnviewedSlideIndex = (item: StoryFeedItem): number => {
  const total = item.slides?.length ?? 0
  if (total === 0) return 0
  if (item.view.is_completed) return 0
  const idx = item.view.max_slide_viewed ?? 0
  return Math.min(Math.max(idx, 0), total - 1)
}
